/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Heading, HStack, Spacer } from '@chakra-ui/react';
import { Bar } from 'react-chartjs-2';
import React, { useEffect } from 'react';
import { useTheme } from '../../../contexts/ThemeProvider';
import { useNavigate } from 'react-router-dom';
import { LuMoveRight } from 'react-icons/lu';
import { useHistory } from '@/service/club/hooks';

export const portugueseMonthLabels = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export function Econometro() {
  const { data: econometer } = useHistory();

  const { colors } = useTheme();
  const [progress, setProgress] = React.useState<any>({
    target: 0,
    progress: [],
  });

  const nav = useNavigate();

  useEffect(() => {
    if (econometer) {

      const currentMonth = 1; // Janeiro
      const currentYear = 2025;
      const extendedProgress = [...econometer.progress];

      // Add two months to the end
      for (let i = 1; i <= 2; i++) {
        const newMonth = (currentMonth + i) % 12 || 12;
        const newYear = currentMonth + i > 12 ? currentYear + 1 : currentYear;
        extendedProgress.push({
          label: `${newMonth}/${newYear}`,
          progress: 0,
          total: 0,
          progress_sales: [],
        });
      }

      const trimmedProgress = extendedProgress.slice(-5);

      setProgress((prev: any) => ({
        ...prev,
        progress: trimmedProgress,
      }));
    }
  }, [econometer]);

  const data: any = {
    labels: progress?.progress.map((p: any) => {
      const [month] = p.label.split('/');

      return portugueseMonthLabels[parseInt(month) - 1].substring(0, 3);
    }),
    datasets: [
      {
        data: progress.progress.map((p: any) => p.progress),
        backgroundColor: colors.primaryColor,
        borderColor: '#FFB800',
        borderRadius: 4,
        borderWidth: 1,
      },
    ],
  };

  const options: any = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      responsive: true,
      legend: {
        display: false,
      },
    },
  };

  return (
    <Box
      maxHeight={300}
      width={'100%'}
      backgroundColor={'white'}
      cursor={'pointer'}
      maxWidth={400}
      onClick={() => nav('/perfil/econometro')}
      padding="22px"
      borderRadius="24px"
      boxShadow={'4px 4px 10px 0px #0000002E'}
    >
      <HStack width={'100%'}>
        <Heading color="#292927" fontSize={'18px'} fontFamily={'Glory'} fontWeight={500}>
          Econômetro
        </Heading>
        <Spacer />
         <LuMoveRight color="#292927" fontSize={'24px'} />
      </HStack>

      <Bar options={options} data={data} />
    </Box>
  );
}
